import { ref, Query } from 'firebase/database'

import firebase from '../utils/firebase'

export function getPlatformCustomerState(uid: string): Query {
  const db = firebase.getDatabase()
  return ref(db, `users/${uid}/platformCustomerState`)
}
